if (!customElements.get('quick-order-list-remove-button')) {
  customElements.define(
    'quick-order-list-remove-button',
    class QuickOrderListRemoveButton extends BulkAdd {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          event.preventDefault();
          this.startQueue(this.dataset.index, 0);
        });
      }
    }
  );
}

if (!customElements.get('quick-order-list-remove-all-button')) {
  customElements.define(
    'quick-order-list-remove-all-button',
    class QuickOrderListRemoveAllButton extends HTMLElement {
      constructor() {
        super();
        this.quickOrderList = this.closest('quick-order-list');
        if (this.quickOrderList) {
          const allVariants = this.quickOrderList.querySelectorAll('[data-quantity-variant-id]');
          const items = {};
          let hasVariantsInCart = false;

          allVariants.forEach((variant) => {
            const cartQty = parseInt(variant.dataset.cartQuantity);
            if (cartQty > 0) {
              hasVariantsInCart = true;
              items[parseInt(variant.dataset.quantityVariantId)] = 0;
            }
          });

          if (!hasVariantsInCart) {
            this.classList.add('hidden');
          }

          this.actions = {
            confirm: 'confirm',
            remove: 'remove',
            cancel: 'cancel',
          };

          this.addEventListener('click', (event) => {
            event.preventDefault();
            if (this.dataset.action === this.actions.confirm) {
              this.toggleConfirmation(false, true);
            } else if (this.dataset.action === this.actions.remove) {
              this.quickOrderList.updateMultipleQty(items);
              this.toggleConfirmation(true, false);
            } else if (this.dataset.action === this.actions.cancel) {
              this.toggleConfirmation(true, false);
            }
          });
        }
      }

      toggleConfirmation(showConfirmation, showInfo) {
        const confirmation = this.quickOrderList.querySelector('.quick-order-list-total__confirmation');
        const info = this.quickOrderList.querySelector('.quick-order-list-total__info');

        confirmation.classList.toggle('hidden', showConfirmation);
        info.classList.toggle('hidden', showInfo);

        if (!showConfirmation) {
          window.setTimeout(() => {
            confirmation.querySelector('.quick-order-list__button-cancel')?.focus({ preventScroll: true });
          }, 0);
        } else {
          this.quickOrderList.querySelector('[data-action="confirm"] button')?.focus({ preventScroll: true });
        }
      }
    }
  );
}

if (!customElements.get('quick-order-list')) {
  customElements.define(
    'quick-order-list',
    class QuickOrderList extends BulkAdd {
      constructor() {
        super();
        this.cart = document.querySelector('cart-drawer');
        this.quickOrderListId = `${this.dataset.section}-${this.dataset.productId}`;
        this.defineInputsAndQuickOrderTable();
        this.variantItemStatusElement = document.getElementById('shopping-cart-variant-item-status');
        const form = this.querySelector('form');
        this.inputFieldHeight = this.querySelector('.variant-item__quantity-wrapper').offsetHeight;
        this.isListInsideModal = document.querySelector('.quick-add-bulk');
        this.stickyHeaderElement = document.querySelector('sticky-header');
        this.getTableHead();
        this.getTotalBar();
        this.activeOffers = [];
        this.getActiveOffers();

        if (this.stickyHeaderElement) {
          this.stickyHeader = {
            height: this.stickyHeaderElement.offsetHeight,
            type: `${this.stickyHeaderElement.getAttribute('data-sticky-type')}`,
          };
        }

        if (this.getTotalBar()) {
          this.totalBarPosition = window.innerHeight - this.getTotalBar().offsetHeight;

          window.addEventListener('resize', () => {
            this.totalBarPosition = window.innerHeight - this.getTotalBar().offsetHeight;
            this.stickyHeader.height = this.stickyHeaderElement ? this.stickyHeaderElement.offsetHeight : 0;
          });
        }

        const pageParams = new URLSearchParams(window.location.search);
        window.pageNumber = decodeURIComponent(pageParams.get('page') || '');
        form.addEventListener('submit', this.onSubmit.bind(this));
        this.addMultipleDebounce();
      }

      cartUpdateUnsubscriber = undefined;

      onSubmit(event) {
        event.preventDefault();
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          const variantIds = [];
          this.querySelectorAll('.variant-item').forEach((item) => {
            variantIds.push(parseInt(item.dataset.variantId));
          });
          if (
            event.source === this.quickOrderListId ||
            !event.cartData.items?.some((element) => variantIds.includes(element.variant_id))
          ) {
            return;
          }
          // If its another section that made the update
          this.refresh().then(() => {
            this.defineInputsAndQuickOrderTable();
            this.addMultipleDebounce();
          });
        });
        this.sectionId = this.dataset.section;
      }

      disconnectedCallback() {
        this.cartUpdateUnsubscriber?.();
      }

      defineInputsAndQuickOrderTable() {
        this.allInputsArray = Array.from(this.querySelectorAll('input[type="number"]'));
        this.quickOrderListTable = this.querySelector('.quick-order-list__table');
        this.quickOrderListTable.addEventListener('focusin', this.switchVariants.bind(this));
      }

      onChange(event) {
        const inputValue = parseInt(event.target.value);
        this.cleanErrorMessageOnType(event);
        if (inputValue == 0) {
          this.startQueue(event.target.dataset.index, inputValue);
        } else {
          this.validateQuantity(event);
        }
      }

      cleanErrorMessageOnType(event) {
        event.target.addEventListener('keydown', () => {
          event.target.setCustomValidity(' ');
          event.target.reportValidity();
        });
      }

      validateInput(target) {
        if (target.max) {
          return (
            parseInt(target.value) == 0 ||
            (parseInt(target.value) >= parseInt(target.dataset.min) &&
              parseInt(target.value) <= parseInt(target.max) &&
              parseInt(target.value) % parseInt(target.step) == 0)
          );
        } else {
          return (
            parseInt(target.value) == 0 ||
            (parseInt(target.value) >= parseInt(target.dataset.min) &&
              parseInt(target.value) % parseInt(target.step) == 0)
          );
        }
      }

      refresh() {
        return new Promise((resolve, reject) => {
          fetch(`${this.getSectionsUrl()}?section_id=${this.sectionId}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const sourceQty = html.querySelector(`#${this.quickOrderListId}`);
              if (sourceQty) {
                this.innerHTML = sourceQty.innerHTML;
              }
              resolve();
            })
            .catch((e) => {
              console.error(e);
              reject(e);
            });
        });
      }

      getSectionsToRender() {
        return [
          {
            id: this.quickOrderListId,
            section: document.getElementById(this.quickOrderListId).dataset.section,
            selector: `#${this.quickOrderListId} .js-contents`,
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: `quick-order-list-total-${this.dataset.productId}-${this.dataset.section}`,
            section: document.getElementById(this.quickOrderListId).dataset.section,
            selector: `#${this.quickOrderListId} .quick-order-list__total`,
          },
          {
            id: 'CartDrawer',
            selector: '#CartDrawer',
            section: 'cart-drawer',
          },
        ];
      }

      addMultipleDebounce() {
        this.querySelectorAll('quantity-input').forEach((qty) => {
          const debouncedOnChange = debounce((event) => {
            this.onChange(event);
          }, 100);
          qty.addEventListener('change', debouncedOnChange.bind(this));
        });
      }

      renderSections(parsedState, ids) {
        this.ids.push(ids);
        const intersection = this.queue.filter((element) => ids.includes(element.id));
        if (intersection.length !== 0) return;

        this.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);
          if (
            sectionElement &&
            sectionElement.parentElement &&
            sectionElement.parentElement.classList.contains('drawer')
          ) {
            parsedState.items.length > 0
              ? sectionElement.parentElement.classList.remove('is-empty')
              : sectionElement.parentElement.classList.add('is-empty');
            setTimeout(() => {
              document.querySelector('#CartDrawer-Overlay').addEventListener('click', this.cart.close.bind(this.cart));
            });
          }
          const elementToReplace =
            sectionElement && sectionElement.querySelector(section.selector)
              ? sectionElement.querySelector(section.selector)
              : sectionElement;
          if (elementToReplace) {
            if (section.selector === `#${this.quickOrderListId} .js-contents` && this.ids.length > 0) {
              this.ids.flat().forEach((i) => {
                elementToReplace.querySelector(`#Variant-${i}`).innerHTML = this.getSectionInnerHTML(
                  parsedState.sections[section.section],
                  `#Variant-${i}`
                );
              });
            } else {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          }
        });
        this.defineInputsAndQuickOrderTable();
        this.addMultipleDebounce();
        this.ids = [];
      }

      getTableHead() {
        return document.querySelector('.quick-order-list__table thead');
      }

      getActiveOffers = async () => {
        const params = {
            productId: __st.rid,
            variantIds: meta.product.variants.map(variant => variant.id)
        };
        const queryString = Object.entries(params).map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join('&');
        fetch(`/apps/proxy/volume-discounts?${queryString}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Referer': Shopify.shop
            }
        }).then(response => (response.json())).then(data => {
          const elligibleOffers = data.data;
          if (elligibleOffers.length) {
              this.activeOffers = elligibleOffers;
              this.setVolumeDiscounts();
          }
        });
      }
      setVolumeDiscounts() {
        if (this.activeOffers.length) {
            this.activeOffers.forEach(offer => {
                if (offer.offer_name) {
                    const variant = document.querySelector(`.variant-item[data-variant-id="${offer.offer_name}"]`);
                    const offerLevels = JSON.parse(offer.offer_levels);
                    if (variant && offerLevels.length) {
                        const volumeTable = this.buildVolumeTable(offerLevels);
                        const descEl = variant.querySelector('.variant-item-description');
                        if (descEl && !descEl.querySelector('.volume-table')) {
                            const detailsEl = variant.querySelector('.variant-item__details');
                            descEl.innerHTML = descEl.innerHTML + volumeTable;
                            detailsEl.innerHTML = detailsEl.innerHTML + volumeTable;
                        }
                    }
                }
            });
        }
      }
      buildVolumeTable(levels) {
        let rows = '';
        levels.forEach((level, index) => {
          const nextOffer = levels[index + 1];
          const toVal = (nextOffer ? `-${nextOffer[0] - 1}` : '+');
          rows += `
            <tr>
              <td>${level[0]}${toVal} <span class="hulk-offer-text"></span></td>
              <td><span class="hulkapps-price">Each <span class="money">$${level[1]}</span></span></td>
            </tr>
          `;
        })
        return `
          <table class="volume-table table table-striped">
            <tbody>
              <tr>
                <th style="border-top-left-radius: 0px;">Minimum Qty</th>
                <th style="border-top-right-radius: 0px;">Discount</th>
              </tr>
              ${rows}
            </tbody>
          </table>
          <p class="discount-disclaimer"><b>*</b>Discounts will be applied automatically at checkout</p>
        `;
      }
      getTotalBar() {
        return this.querySelector('.quick-order-list__total');
      }

      scrollQuickOrderListTable() {
        const inputTopBorder = this.variantListInput.getBoundingClientRect().top;
        const inputBottomBorder = this.variantListInput.getBoundingClientRect().bottom;

        if (this.isListInsideModal) {
          const totalBarCrossesInput = inputBottomBorder > this.getTotalBar().getBoundingClientRect().top;
          const tableHeadCrossesInput = inputTopBorder < this.getTableHead().getBoundingClientRect().bottom;

          if (totalBarCrossesInput || tableHeadCrossesInput) {
            this.scrollToCenter();
          }
        } else {
          const stickyHeaderBottomBorder =
            this.stickyHeaderElement && this.stickyHeaderElement.getBoundingClientRect().bottom;
          const totalBarCrossesInput = inputBottomBorder > this.totalBarPosition;
          const inputOutsideOfViewPort = inputBottomBorder < this.inputFieldHeight;
          const stickyHeaderCrossesInput =
            this.stickyHeaderElement &&
            this.stickyHeader.type !== 'on-scroll-up' &&
            this.stickyHeader.height > inputTopBorder;
          const stickyHeaderScrollupCrossesInput =
            this.stickyHeaderElement &&
            this.stickyHeader.type === 'on-scroll-up' &&
            this.stickyHeader.height > inputTopBorder &&
            stickyHeaderBottomBorder > 0;

          if (
            totalBarCrossesInput ||
            inputOutsideOfViewPort ||
            stickyHeaderCrossesInput ||
            stickyHeaderScrollupCrossesInput
          ) {
            this.scrollToCenter();
          }
        }
      }

      scrollToCenter() {
        this.variantListInput.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }

      switchVariants(event) {
        if (event.target.tagName !== 'INPUT') {
          return;
        }

        this.variantListInput = event.target;
        this.variantListInput.select();
        if (this.allInputsArray.length !== 1) {
          this.variantListInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              e.target.blur();
              if (this.validateInput(e.target)) {
                const currentIndex = this.allInputsArray.indexOf(e.target);
                this.lastKey = e.shiftKey;
                if (!e.shiftKey) {
                  const nextIndex = currentIndex + 1;
                  const nextVariant = this.allInputsArray[nextIndex] || this.allInputsArray[0];
                  nextVariant.select();
                } else {
                  const previousIndex = currentIndex - 1;
                  const previousVariant =
                    this.allInputsArray[previousIndex] || this.allInputsArray[this.allInputsArray.length - 1];
                  this.lastElement = previousVariant.dataset.index;
                  previousVariant.select();
                }
              }
            }
          });

          this.scrollQuickOrderListTable();
        } else {
          this.variantListInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              e.target.blur();
            }
          });
        }
      }

      updateMultipleQty(items) {
        this.querySelector('.variant-remove-total .loading__spinner')?.classList.remove('hidden');
        const ids = Object.keys(items);
        const focusTarget = this.getFocusTarget();

        const body = JSON.stringify({
          updates: items,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: this.dataset.url,
        });

        this.updateMessage();
        this.setErrorMessage();

        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            this.renderSections(parsedState, ids);
            this.restoreFocus(focusTarget);
            this.announceTotals(ids);
            publish(PUB_SUB_EVENTS.cartUpdate, { source: this.quickOrderListId, cartData: parsedState });
          })
          .catch(() => {
            this.setErrorMessage(window.cartStrings.error);
          })
          .finally(() => {
            this.querySelector('.variant-remove-total .loading__spinner')?.classList.add('hidden');
            this.requestStarted = false;
            this.setVolumeDiscounts();
          });
      }

      setErrorMessage(message = null) {
        this.errorMessageTemplate =
          this.errorMessageTemplate ??
          document.getElementById(`QuickOrderListErrorTemplate-${this.dataset.productId}`).cloneNode(true);
        const errorElements = document.querySelectorAll('.quick-order-list-error');

        errorElements.forEach((errorElement) => {
          errorElement.innerHTML = '';
          if (!message) return;
          const updatedMessageElement = this.errorMessageTemplate.cloneNode(true);
          updatedMessageElement.content.querySelector('.quick-order-list-error-message').innerText = message.trim();
          errorElement.appendChild(updatedMessageElement.content);
        });
      }

      updateMessage(quantity = null) {
        const messages = this.querySelectorAll('.quick-order-list__message-text');
        const icons = this.querySelectorAll('.quick-order-list__message-icon');

        if (quantity === null || isNaN(quantity)) {
          messages.forEach((message) => (message.innerHTML = ''));
          icons.forEach((icon) => icon.classList.add('hidden'));
          return;
        }

        const isQuantityNegative = quantity < 0;
        const absQuantity = Math.abs(quantity);

        const textTemplate = isQuantityNegative
          ? absQuantity === 1
            ? window.quickOrderListStrings.itemRemoved
            : window.quickOrderListStrings.itemsRemoved
          : quantity === 1
          ? window.quickOrderListStrings.itemAdded
          : window.quickOrderListStrings.itemsAdded;

        messages.forEach((msg) => (msg.innerHTML = textTemplate.replace('[quantity]', absQuantity)));

        if (!isQuantityNegative) {
          icons.forEach((i) => i.classList.remove('hidden'));
        }
      }

      updateError(updatedValue, id) {
        let message = '';
        if (typeof updatedValue === 'undefined') {
          message = window.cartStrings.error;
        } else {
          message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
        }
        this.updateLiveRegions(id, message);
      }

      cleanErrors(id) {
        // this.querySelectorAll('.desktop-row-error').forEach((error) => error.classList.add('hidden'));
        // this.querySelectorAll(`.variant-item__error-text`).forEach((error) => error.innerHTML = '');
      }

      getFocusTarget() {
        const activeElement = document.activeElement;
        const variantRow = activeElement?.closest('[data-variant-id]');

        return {
          id: activeElement?.id,
          name: activeElement?.getAttribute('name'),
          variantId: activeElement?.dataset?.quantityVariantId || variantRow?.dataset?.variantId,
        };
      }

      restoreFocus(focusTarget) {
        if (!focusTarget) return;

        const { id, name, variantId } = focusTarget;
        let elementToFocus = null;

        if (id) {
          elementToFocus = document.getElementById(id);
        }

        if (!elementToFocus && variantId && name) {
          elementToFocus = this.querySelector(
            `#Variant-${CSS.escape(String(variantId))} [name="${CSS.escape(name)}"]`
          );
        }

        if (!elementToFocus && variantId) {
          elementToFocus = this.querySelector(`#Quantity-${CSS.escape(String(variantId))}`);
        }

        if (elementToFocus?.focus) {
          elementToFocus.focus({ preventScroll: true });
        }
      }

      getTotalsStatusElement() {
        return this.getTotalBar()?.querySelector('[data-quick-order-totals-status]');
      }

      getTotalsAnnouncementElement() {
        return this.getTotalsStatusElement()?.querySelector('[data-quick-order-totals-announcement]');
      }

      getLiveRegionElement() {
        return (
          document.getElementById(`quick-order-list-live-region-text-${this.dataset.productId}`) ||
          document.getElementById('quick-order-list-live-region-text')
        );
      }

      announceTotals(updatedVariantIds = []) {
        const runAnnouncement = () => {
          const totalBar = this.getTotalBar();
          const totalsStatus = this.getTotalsStatusElement();
          const totalsAnnouncement = this.getTotalsAnnouncementElement();
          if (!totalBar || !totalsStatus || !totalsAnnouncement) return;

          const itemCount = totalBar.querySelector('.quick-order-list__total-items span')?.textContent?.trim();
          const subtotal = totalBar.querySelector('.totals__subtotal-value')?.textContent?.trim();

          if (!itemCount || !subtotal) return;

          const announcementParts = [];

          if (updatedVariantIds.length === 1) {
            const variantId = String(updatedVariantIds[0]);
            const variantRow = this.querySelector(`#Variant-${CSS.escape(variantId)}`);
            const label =
              variantRow?.querySelector('.variant-item__sku')?.textContent?.replace(/\s+/g, ' ').trim() ||
              variantRow?.querySelector('.variant-item__name')?.textContent?.replace(/\s+/g, ' ').trim();
            const quantity = variantRow?.querySelector('[data-quantity-variant-id]')?.value;
            const lineTotal = variantRow
              ?.querySelector('.variant-item__totals .price')
              ?.textContent?.replace(/\s+/g, ' ')
              .trim();
            const unitPrice = variantRow
              ?.querySelector('.variant-item__price .price-per-item--current, .variant-item__price > .price')
              ?.textContent?.replace(/\s+/g, ' ')
              .trim();

            if (label && quantity) {
              let lineAnnouncement = `${label}. Quantity: ${quantity}.`;
              if (lineTotal) {
                lineAnnouncement += ` Line total: ${lineTotal}.`;
              } else if (unitPrice) {
                lineAnnouncement += ` Unit price: ${unitPrice}.`;
              }
              announcementParts.push(lineAnnouncement);
            }
          }

          announcementParts.push(
            `${itemCount} ${Number(itemCount) === 1 ? 'item' : 'items'}. Product subtotal: ${subtotal}.`
          );

          const announcement = announcementParts.join(' ');

          totalsStatus.setAttribute('role', 'status');
          totalsStatus.setAttribute('aria-live', 'assertive');
          totalsStatus.setAttribute('aria-atomic', 'true');
          totalsStatus.removeAttribute('aria-hidden');

          // Clear first so repeated updates still announce when totals are unchanged.
          window.clearTimeout(this.totalsAnnouncementTimeout);
          totalsAnnouncement.textContent = '';

          this.totalsAnnouncementTimeout = window.setTimeout(() => {
            totalsAnnouncement.textContent = announcement;
          }, 300);
        };

        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(runAnnouncement);
        });
      }

      updateLiveRegions(id, message) {
        const variantItemErrorDesktop = document.getElementById(`Quick-order-list-item-error-desktop-${id}`);
        const variantItemErrorMobile = document.getElementById(`Quick-order-list-item-error-mobile-${id}`);
        if (variantItemErrorDesktop) {
          variantItemErrorDesktop.querySelector('.variant-item__error-text').innerHTML = message;
          variantItemErrorDesktop.closest('tr').classList.remove('hidden');
        }
        if (variantItemErrorMobile)
          variantItemErrorMobile.querySelector('.variant-item__error-text').innerHTML = message;

        this.variantItemStatusElement.setAttribute('aria-hidden', true);

        const cartStatus = this.getLiveRegionElement();
        if (!cartStatus) return;

        cartStatus.setAttribute('aria-live', 'polite');
        cartStatus.removeAttribute('aria-hidden');
        cartStatus.textContent = message;
      }

      toggleLoading(id, enable) {
        const quickOrderListItems = this.querySelectorAll(`#Variant-${id} .loading__spinner`);
        const quickOrderListItem = this.querySelector(`#Variant-${id}`);

        if (enable) {
          quickOrderListItem.classList.add('quick-order-list__container--disabled');
          [...quickOrderListItems].forEach((overlay) => overlay.classList.remove('hidden'));
          this.variantItemStatusElement.setAttribute('aria-hidden', false);
        } else {
          quickOrderListItem.classList.remove('quick-order-list__container--disabled');
          quickOrderListItems.forEach((overlay) => overlay.classList.add('hidden'));
        }
      }
    }
  );
}
